import { FormValidationMessages } from "./Languages";
const FormValidation = (FieldName, Label, ValidationTypeArray) => {
  if (!ValidationTypeArray) {
    return 0;
  }
  let validationArr = ValidationTypeArray?.map(({ Type, value, message }) => {
    let msg = message
      ? message
      : FormValidationMessages(FieldName, Label, Type, value);
    return {
      [Type]: Type == "required" ? msg : { value: value, message: msg },
    };
  });
  return validationArr.reduce(function (result, item) {
    var key = Object.keys(item)[0];
    result[key] = item[key];
    return result;
  }, {});
};
export default FormValidation;
